document.addEventListener('DOMContentLoaded', () => {

  // --- Brand Name Formatting ---
  function formatJuliText() {
    const mainContent = document.getElementById('MainContent');
    if (!mainContent) return;

    // Match "juli" as a standalone word (\b is word boundary), case-insensitive (i)
    const regex = /\b(juli)\b/gi;

    // TreeWalker safely traverses pure text nodes only
    const walker = document.createTreeWalker(mainContent, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (!node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        
        const parent = node.parentNode;
        if (!parent) return NodeFilter.FILTER_REJECT;
        
        const parentTag = parent.nodeName.toLowerCase();
        
        // Skip code blocks, styles, and nodes that are already wrapped
        if (['script', 'style', 'noscript'].includes(parentTag)) return NodeFilter.FILTER_REJECT;
        if (parent.classList && parent.classList.contains('juli')) return NodeFilter.FILTER_REJECT;
        
        return regex.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    const nodesToReplace = [];
    let node;
    while (node = walker.nextNode()) {
      nodesToReplace.push(node);
    }

    nodesToReplace.forEach(textNode => {
      const parent = textNode.parentNode;
      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      const text = textNode.nodeValue;
      
      regex.lastIndex = 0;
      let match;
      
      while ((match = regex.exec(text)) !== null) {
        // Add preceding text
        if (match.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
        }
        
        // Add wrapped span
        const span = document.createElement('span');
        span.className = 'juli';
        span.textContent = match[0]; 
        fragment.appendChild(span);
        
        lastIndex = regex.lastIndex;
      }
      
      // Add trailing text
      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
      }
      
      parent.replaceChild(fragment, textNode);
    });
  }

  // Run text formatter immediately
  formatJuliText();

  // --- External Links ---
  document.querySelectorAll('a[href^="http"]').forEach(link => {
    if (link.hostname !== window.location.hostname) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });

  // --- Slider Progress Bars ---
  function initSliderProgressBars() {
    const counters = document.querySelectorAll('.slider-counter:not(.has-progress-bar)');

    counters.forEach(counter => {
      const currentSpan = counter.querySelector('.slider-counter--current');
      const totalSpan = counter.querySelector('.slider-counter--total');

      if (!currentSpan || !totalSpan) return;

      counter.classList.add('has-progress-bar');

      if (!counter.querySelector('.slider-progress-track')) {
        const track = document.createElement('div');
        track.className = 'slider-progress-track';
        const fill = document.createElement('div');
        fill.className = 'slider-progress-fill';
        track.appendChild(fill);
        counter.appendChild(track);
      }
      
      const fill = counter.querySelector('.slider-progress-fill');

      const updateProgressBar = () => {
        const current = parseInt(currentSpan.textContent.trim(), 10) || 1;
        const total = parseInt(totalSpan.textContent.trim(), 10) || 1; 
        const percentage = (current / total) * 100;
        fill.style.width = `${percentage}%`;
      };

      updateProgressBar();

      const observer = new MutationObserver(updateProgressBar);
      const config = { characterData: true, subtree: true, childList: true };
      observer.observe(currentSpan, config);
      observer.observe(totalSpan, config);
    });
  }

  // 1. Run immediately for sliders already on the page
  initSliderProgressBars();

  // 2. Watch the DOM for dynamically injected elements
  const globalDOMObserver = new MutationObserver((mutations) => {
    let shouldInitSlider = false;
    let shouldFormatText = false;
    
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length > 0) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) { 
            if (node.classList.contains('slider-counter') || node.querySelector('.slider-counter')) {
              shouldInitSlider = true;
            }
            // Trigger text formatting if any new element is dynamically injected
            shouldFormatText = true; 
          }
        }
      }
    });

    if (shouldInitSlider) initSliderProgressBars();
    if (shouldFormatText) formatJuliText(); 
  });

  // Start observing the body for injected content
  globalDOMObserver.observe(document.body, { childList: true, subtree: true });

  // --- Free Gifts ---
  // Ported from the pre-Dawn theme. Gift lines carry a `_bonus` line item property (hidden in the
  // cart, used to lock quantity). The $0 price itself comes from automatic discounts in Shopify
  // Discounts, so keep those active. Toggles: Theme settings > Cart > Free gifts.
  const FREE_GIFTS = {
    foamVariantId: 40713463890073,
    kitVariantId: 17721886933082, // Diamond Cleaning Essentials Kit
    subscriptionBonusQty: 2,
    subscriptionBonusLabel: 'Subscription Gift',
    kitBonusQty: 1,
    kitBonusLabel: 'Kit Gift',
  };
  const giftSettings = window.juliGifts || {};
  let giftSyncRunning = false;

  const fetchCart = () => fetch(`${routes.cart_url}.js`).then((response) => response.json());

  const cartPost = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => {
      if (!response.ok) throw new Error(`${url} ${response.status}`);
      return response.json();
    });

  const giftLabel = (item) => (item.properties && item.properties._bonus) || '';

  // Make the bonus lines with this label total `want`: add the shortfall or trim the excess.
  async function reconcileGiftLines(cart, variantId, label, want) {
    const lines = cart.items
      .map((item, index) => ({ item, line: index + 1 }))
      .filter(({ item }) => item.variant_id === variantId && giftLabel(item) === label);
    const have = lines.reduce((sum, { item }) => sum + item.quantity, 0);

    if (have < want) {
      await cartPost(`${routes.cart_add_url}.js`, {
        items: [{ id: variantId, quantity: want - have, properties: { _bonus: label } }],
      });
      return true;
    }

    let excess = have - want;
    // Highest line first so removing a line doesn't shift the ones still to be changed.
    for (const { item, line } of lines.reverse()) {
      if (excess <= 0) break;
      const remove = Math.min(excess, item.quantity);
      await cartPost(`${routes.cart_change_url}.js`, { line, quantity: item.quantity - remove });
      excess -= remove;
    }
    return have !== want;
  }

  // Returns whether the cart changed. Pass { refresh: false } when the caller refreshes the cart UI itself.
  async function syncFreeGifts(trigger, { refresh = true } = {}) {
    if (giftSyncRunning) return false;
    giftSyncRunning = true;
    let changed = false;

    try {
      const cart = await fetchCart();
      const { foamVariantId, kitVariantId } = FREE_GIFTS;

      // 1. Foam on a subscription plan -> exactly 2 free Foam; none if the subscription is gone.
      if (giftSettings.subscriptionBonus !== false) {
        const hasSubscription = cart.items.some(
          (item) => item.variant_id === foamVariantId && item.selling_plan_allocation && !giftLabel(item)
        );
        changed = await reconcileGiftLines(
          cart,
          foamVariantId,
          FREE_GIFTS.subscriptionBonusLabel,
          hasSubscription ? FREE_GIFTS.subscriptionBonusQty : 0
        );
      }

      // 2. Essentials Kit -> free Foam. Only added when something was just added to the cart (so a
      // customer who removes the kit isn't fighting it), but removed again if the kit goes away.
      if (!changed && giftSettings.kitBonus !== false) {
        const hasKit = cart.items.some((item) => item.variant_id === kitVariantId);
        const hasFoam = cart.items.some((item) => item.variant_id === foamVariantId && !giftLabel(item));
        const hasKitGift = cart.items.some((item) => giftLabel(item) === FREE_GIFTS.kitBonusLabel);
        let want = null;
        if (!hasKit && hasKitGift) want = 0;
        else if (hasKit && !hasFoam && trigger === 'add') want = FREE_GIFTS.kitBonusQty;
        if (want !== null) {
          changed = await reconcileGiftLines(cart, foamVariantId, FREE_GIFTS.kitBonusLabel, want);
        }
      }
    } catch (error) {
      console.error('Free gifts:', error);
    } finally {
      giftSyncRunning = false;
    }

    if (changed && refresh) await refreshCartUI('free-gifts');
    return changed;
  }

  async function refreshCartUI(source) {
    // The cart page has several independent sections (items, totals), so just reload it.
    if (window.location.pathname === routes.cart_url) {
      window.location.reload();
      return;
    }

    try {
      const cart = await fetchCart();
      await publish(PUB_SUB_EVENTS.cartUpdate, { source, cartData: cart });

      const html = await fetch(`${routes.cart_url}?section_id=cart-icon-bubble`).then((response) => response.text());
      const bubble = document.getElementById('cart-icon-bubble');
      const freshBubble = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    } catch (error) {
      console.error('Cart refresh:', error);
    }
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    // Our own refreshes; the upsell runs the gift sync itself before refreshing.
    if (event && (event.source === 'free-gifts' || event.source === 'cart-upsell')) return;
    const added = event && (event.source === 'product-form' || event.source === 'quick-add');
    return syncFreeGifts(added ? 'add' : 'update');
  });

  syncFreeGifts('load');

  // --- Cart Upsell ---
  // Buttons rendered by snippets/cart-upsell.liquid (cart drawer + cart page). An upsell adds the
  // product; an upgrade replaces the cart with it. Free gifts are then synced as for any add.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-upsell-button]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    try {
      if (button.dataset.mode === 'upgrade') await cartPost(`${routes.cart_url}/clear.js`, {});
      await cartPost(`${routes.cart_add_url}.js`, {
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
      });
      await syncFreeGifts('add', { refresh: false });
      await refreshCartUI('cart-upsell');
    } catch (error) {
      console.error('Cart upsell:', error);
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    }
  });

  // --- Smooth Scrolling for Anchors ---
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          const targetId = this.getAttribute('href');
          if (targetId === '#') return;

          const targetElement = document.querySelector(targetId);

          if (targetElement) {
              e.preventDefault();

              const header = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
              const offset = header ? header.offsetHeight : 100;

              const elementPosition = targetElement.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;

              window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth"
              });
          }
      });
  });
  
});